import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Grupo } from 'app/_class/grupo';
import { CookieService } from 'ngx-cookie-service';
import { AuthService } from 'app/_utils/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class GroupsService {

  constructor(private http: HttpClient, private cookieService: CookieService) { }

  async getGrupos(idCliente: number) {
    // Cliente especial usa API jerárquica
    if (idCliente === environment.idClientSaesa) {
      return this.getGruposJerarquicos(idCliente);
    }

    // Token es la cookie at (access token) de cognito. Necesario si se quiere consultar
    // los grupos de un cliente filtrados por los que tiene disponible el usuario.
    // El filtro solo aplica a usuarios supervisores y normales, mas no a administradores.
    const at = await AuthService.getAt()
    
    let token = '';
    if ( at !== null && at !== undefined && at !== '' ) {
      token = '&user_token=' + await AuthService.getAt();
    }
    const url = `${environment.endPoint}/ClientSite/api/GetGrupo?id_cliente=${idCliente}${token}`;

    const wpsid = this.cookieService.get('wpsid');
    const headers = new HttpHeaders({
      'id-client': `${idCliente}`,
      'Authorization': `Bearer ${at}`
    });
    let groups: Grupo[] = [];

    await this.http.get<Grupo[]>(url, { headers, withCredentials: true})
    .toPromise()
    .then(data => {
      groups = data;
    });

    return groups;
  }

  async getGruposJerarquicos(idCliente: number) {
    const at = await AuthService.getAt();
    const userId = this.getUserId();
    
    if (!at) {
      return [];
    }
    
    const url = `${environment.endPoint}/ClientSite/api/GetUserGroup/${userId}`;

    const wpsid = this.cookieService.get('wpsid');
    const headers = new HttpHeaders({
      'id-client': `${idCliente}`,
      'Authorization': `Bearer ${at}`
    });

    try {
      const response: any = await this.http.get(url, { headers }).toPromise();
      
      if (response && response.status && response.data) {
        // Transformar el formato para que sea compatible con la interfaz Grupo
        return response.data.map((item: { id_public: number; public_name: string; clase: number; level: number; id_parent_public: number; }) => ({
          id: item.id_public,
          nombre: item.public_name,
          clase: item.clase,
          level: item.level,
          id_parent: item.id_parent_public
        }));
      }
      
      return [];
    } catch (error) {
      console.error('Error obteniendo grupos jerárquicos:', error);
      return [];
    }
  }
  
  // Este método obtiene el ID del usuario actual
  getUserId(): number{
    try {
      const userId = localStorage.getItem('0x100');
      if (userId) {
        return Number(userId);
      }

      return 0; // Valor por defecto si no se puede obtener el ID del usuario
    } catch (error) {
      console.error('Error obteniendo ID del usuario:', error);
      return 0;
    }
  }
}
